import React from 'react';

const TermsHero = () => {
  return (
    <section
      style={{
        position: 'relative',
        height: '520px',
        overflow: 'hidden',
        marginTop: '72px'
      }}>
      
      {/* Background image */}
      <img
        src="https://img.rocket.new/generatedImages/rocket_gen_img_1217eb179-1772191889926.png"
        alt="Dramatic Norwegian mountain road winding through snow-covered peaks with dramatic stormy sky"
        style={{
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          objectPosition: 'center 40%',
          filter: 'brightness(0.3) contrast(1.25) saturate(0.5)'
        }} />
      

      {/* Gradient overlay */}
      <div
        style={{
          position: 'absolute',
          inset: 0,
          background: 'linear-gradient(135deg, rgba(5,10,18,0.75) 0%, rgba(249,115,22,0.1) 50%, rgba(5,10,18,0.85) 100%)'
        }} />
      

      {/* Ghost number */}
      <div
        style={{
          position: 'absolute',
          top: '-20px',
          right: '5%',
          fontFamily: 'Impact, sans-serif',
          fontSize: 'clamp(8rem, 20vw, 18rem)',
          fontWeight: 900,
          color: 'rgba(249,115,22,0.05)',
          lineHeight: 1,
          userSelect: 'none',
          letterSpacing: '-0.05em'
        }}>
        
        §§
      </div>

      {/* Content */}
      <div
        style={{
          position: 'absolute',
          inset: 0,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'flex-end',
          padding: '0 5% 60px'
        }}>
        
        {/* Tag */}
        <div
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '8px',
            background: 'rgba(249,115,22,0.15)',
            border: '1px solid rgba(249,115,22,0.35)',
            padding: '6px 14px',
            marginBottom: '20px',
            width: 'fit-content'
          }}>
          
          <div style={{ width: '6px', height: '6px', background: '#F97316', borderRadius: '50%' }} />
          <span
            style={{
              fontFamily: 'JetBrains Mono, monospace',
              fontSize: '0.6875rem',
              color: '#F97316',
              letterSpacing: '0.12em',
              textTransform: 'uppercase'
            }}>
            
            NORSK JURISDIKSJON · OPPDATERT FEBRUAR 2026
          </span>
        </div>

        {/* Title */}
        <div style={{ position: 'relative' }}>
          <h1
            style={{
              fontFamily: 'Impact, sans-serif',
              fontSize: 'clamp(2.5rem, 7vw, 6.5rem)',
              fontWeight: 900,
              color: '#EEF0F2',
              lineHeight: 0.9,
              letterSpacing: '-0.02em',
              textTransform: 'uppercase',
              transform: 'rotate(-1.5deg)',
              transformOrigin: 'left bottom',
              marginBottom: '4px'
            }}>
            
            VILKÅR &
          </h1>
          <h1
            style={{
              fontFamily: 'Impact, sans-serif',
              fontSize: 'clamp(2.5rem, 7vw, 6.5rem)',
              fontWeight: 900,
              color: '#F97316',
              lineHeight: 0.9,
              letterSpacing: '-0.02em',
              textTransform: 'uppercase',
              transform: 'rotate(-1.5deg)',
              transformOrigin: 'left bottom',
              marginBottom: '12px'
            }}>
            
            BETINGELSER
          </h1>
          <h2
            style={{
              fontFamily: 'Georgia, serif',
              fontStyle: 'italic',
              fontSize: 'clamp(1rem, 2.5vw, 1.875rem)',
              color: 'rgba(238,240,242,0.55)',
              fontWeight: 400,
              marginTop: '12px'
            }}>
            
            Brukervilkår & Tjenestebetingelser — NordPass AS
          </h2>
        </div>
      </div>
    </section>);

};

export default TermsHero;